// import * as THREE from 'three';
// 定义顶点着色器
// 顶点着色器
export const vertexShader = `
// uniform mat4 modelMatrix;//不需要声明
varying vec3 v_position;
varying vec2 vUv;
void main(){
  // 模型矩阵modelMatrix对顶点位置坐标进行模型变换
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  v_position = position;
  vUv = uv; // x => 0-1. y 0-1
}`;
// 片元着色器
export const fragmentShader = `
//在预处理阶段，编译器会在程序中使用#define定义的标识符替换成stuff。define定义的标识符的时候，后面加上“;”会将“;”认为是stuff中的内容。
#define PI 3.14159265359 

varying vec3 v_position;
varying vec2 vUv;

uniform float v_time;
uniform float opacity;
// roi
uniform vec3 roi_color;
uniform float roi_opacity;
uniform bool is_roi;

// 墙体
uniform vec3 wall_color;
uniform bool is_wall;
uniform float wall_opacity;

// 边框
uniform vec3 border_color;
uniform float border_uvh;
uniform bool is_border;

// 停车位
uniform vec3 park_color;
uniform float park_uvh;
uniform bool is_park;

// 移动的光带颜色
uniform vec3 v_color;
uniform bool isShowMoveLine;
uniform float line_opacity;
uniform bool  isMoveLineAutoOpacity;

// 斜纹
uniform bool isTwill; 

float size = 1.0/10.0; // 0.1
// 旋转方法
mat2 rotate2d(float _angle){
   return mat2(cos(_angle),-sin(_angle),
    sin(_angle),cos(_angle));
}

void main() {
   float v = v_time;
   float percent = vUv.y / 1.0;


   float  percent_smooth = 1.0- smoothstep(0.0,1.0, percent);
   vec4 borderColor = vec4(border_color,1.0);
   vec4 wallColor = vec4(wall_color, percent_smooth);
   vec4 parkColor = vec4(park_color, 1.0);  
   
   vec4 roiColor=  vec4(roi_color, roi_opacity);
  
   if(mod(vUv.y,1.0) == 0.0) {
      float alph = is_roi ?  roi_opacity : 0.0;
      gl_FragColor=  vec4(roi_color, alph*opacity);
   } else if(mod(vUv.y,1.0) == park_uvh){
      float alph = is_park ?  percent_smooth : 0.0;
      gl_FragColor = vec4(park_color, alph*opacity);  
   } else if(mod(vUv.y,1.0) == border_uvh) {
      float alph = is_border ?  percent_smooth : 0.0;
      gl_FragColor =vec4(border_color, alph*opacity);
   } else {
      if(!is_wall)return;
      float alph = is_wall ?  percent_smooth : 0.0;
      gl_FragColor = vec4(wall_color, alph*wall_opacity*opacity);
      if(isTwill) {
         // 斜纹
         float alph =  abs( cos( vUv.y *PI ))  ;
         gl_FragColor = vec4(wall_color, alph*wall_opacity*opacity);

         vec2 st = rotate2d(PI/4.)* vUv;
         float modY =  mod(st.y-v,size);
         if( modY < 0.05 ) {
            float modx = abs(st.x - 0.5);
            gl_FragColor = vec4(mix(wall_color, vec3(1.,1.,1.), 1. - modx), wall_opacity*opacity);
         }
      } else {
         if(isShowMoveLine) {
            // if(mod(vUv.y-v,size) < 0.001 ) {
            //    gl_FragColor = vec4(v_color,   alph*line_opacity*opacity);
            // }else if(mod(vUv.y-v,size) >0.001 && mod(vUv.y-v,size) < 0.005) {
            //     gl_FragColor = vec4(v_color, alph*line_opacity*opacity);
            // } else  {
            //    float alph = is_wall ?  percent_smooth : 0.0;
            //    gl_FragColor = vec4(wall_color, alph*wall_opacity*opacity);
            // } 
            // 自适应光墙透明度
            if( isMoveLineAutoOpacity) {
               if(mod(vUv.y-v,size) < 0.005 ) {
                  gl_FragColor = vec4(v_color,alph*line_opacity*opacity);
               }
            } else {
               if(mod(vUv.y-v,size) < 0.001 ) {
                  gl_FragColor = vec4(border_color, (1.0-percent)*0.6*opacity);
               }else if( mod(vUv.y-v,size) < 0.01) {
                  // 移动光带
                  float  moveLineOpacity =  1.;
                  gl_FragColor = vec4(v_color, moveLineOpacity*opacity);
               } else if( mod(vUv.y-v,size) < 0.06) {
                  float  moveLineOpacity = isMoveLineAutoOpacity ? percent_smooth:  (0.06 -mod(vUv.y-v,size))*20.  ;
                  gl_FragColor = vec4(wall_color, moveLineOpacity*opacity);
               }
            }
         }
      }
     
   }
}
`;
